const userFlowPaths = [
  /\/dashboard\/*/,
  /\/organizations\/create/,
  /\/organizations/,
  /\/post-a-listing/,
  /\/sign-up-to-post/,
  /\/admin\/*/,
  /\/salaries\/*/,
  /\/grad-schools\/*/,
  /\/grad-program\/*/,
  /\/*-job\/*/,
];

export function inNoninterruptibleUserFlow(pathname: string) {
  return userFlowPaths.some((flowPath) => flowPath.test(pathname));
}
